<app-header></app-header>
<app-nav></app-nav>
<app-footer></app-footer>
